import { Layout } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const { Header } = Layout;

const LOGO = `${process.env.PUBLIC_URL}/throwly-256.png`;

const RED = "#ff4757";

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { label: "Overview", href: "/overview" },
    { label: "AI Estimate", href: "/ai-estimate" },
    { label: "About", href: "/about" },
  ];

  const isActive = (href: string) => location.pathname === href;

  return (
    <Header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "rgba(255,255,255,0.96)",
        backdropFilter: "blur(12px)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 40px",
        borderBottom: "1px solid rgba(0,0,0,0.07)",
        boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
        height: 64,
      }}
    >
      <style>{`
        .nb-link {
          font-size: 14px; font-weight: 500; color: #64748b;
          text-decoration: none; line-height: normal;
          transition: color 0.2s;
          white-space: nowrap;
        }
        .nb-link:hover { color: ${RED}; }
        .nb-link.nb-active { color: ${RED}; text-decoration: underline; text-underline-offset: 5px; text-decoration-thickness: 2px; text-decoration-color: ${RED}; }
      `}</style>

      {/* Logo */}
      <div
        style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", flexShrink: 0 }}
        onClick={() => navigate("/")}
      >
        <img src={LOGO} alt="Throwly Logo" style={{ height: 40, width: 40, borderRadius: 9, objectFit: "contain" }} />
        <span style={{ fontSize: 22, fontWeight: 700, color: "#1a202c", letterSpacing: "-0.3px" }}>
          Throwly
        </span>
      </div>

      {/* Nav Links */}
      <nav style={{ display: "flex", alignItems: "center", gap: 32, flex: 1, justifyContent: "center" }}>
        {navLinks.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className={`nb-link${isActive(link.href) ? " nb-active" : ""}`}
          >
            {link.label}
          </a>
        ))}
      </nav>

      {/* Spacer to keep nav centered now that auth/post actions are removed */}
      <div style={{ flexShrink: 0, width: 200 }} />
    </Header>
  );
};

export default NavBar;
